import { get, post, put } from './https';

export const GetRequestList = async ({
  page = 1,
  limit = 10,
  searchQuery = '',
}: {
  page?: number;
  limit?: number;
  searchQuery?: string;
}) => {
  let url = `/api/v1/admin/tool/request/list?limit=${limit}&page=${page}`;

  if (searchQuery) {
    url += `&search=${searchQuery}`;
  }

  const response = await get(url);

  if (response.status == 200) {
    return response.data;
  } else {
    throw new Error('Failed to fetch taxation');
  }
};

export const updateToolRequestStatus = async (
  requestId: string,
  status: 'APPROVED' | 'DENIED' | 'ASSIGNED',
): Promise<void> => {
  await put('/api/v1/admin/tool/request/approve', { requestId, status });
};

export const EnquiryDetail = async (id: string) => {
  const url = `/api/v1/admin/enquiry/${id}`;
  const response = await get(url);

  if (response.status == 200) {
    return response.data;
  } else {
    throw new Error('Failed to fetch booking details');
  }
};

export const AssignInspector = async (
  enquiryId: string,
  technicianId: string,
  assignmentType: string,
): Promise<number> => {
  const url = `/api/v1/admin/enquiry/assign_technician`;
  const response = await post(url, {
    enquiryId,
    technicianId,
    assignmentType,
  });
  if (response.status == 200) {
    return 200;
  } else {
    throw new Error('Failed to Assign Technician to Booking');
  }
};
